import { colors, Spinner } from '@custom-components';
import MenuItem from '@mui/material/MenuItem';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import React from 'react';
import styled from 'styled-components';

const HighlightedSuggestionText = styled.span`
  font-weight: 600;
`;

const SuggestionText = styled.strong`
  font-weight: 300;
`;

export const renderSuggestion = ({ suggestion, index, itemProps, highlightedIndex, selectedItem, inputValue }) => {
  const { value, label } = suggestion;
  const isHighlighted = highlightedIndex === index;
  const isSelected = selectedItem && value === selectedItem;
  const matches = match(label, inputValue);
  const parts = parse(label, matches);
  return (
    <MenuItem
      {...itemProps}
      key={value}
      selected={isHighlighted}
      component="div"
      style={{
        fontWeight: isSelected ? 500 : 400,
        display: 'block',
        background: isHighlighted ? colors.flagGrey : 'white'
      }}
    >
      {parts.map(({ highlight, text }) => {
        const Text = highlight ? HighlightedSuggestionText : SuggestionText;
        return <Text>{text}</Text>;
      })}
    </MenuItem>
  );
};

export function LoadingSuggestion() {
  return (
    <MenuItem style={{ display: 'flex', justifyContent: 'space-around' }}>
      <Spinner thickness={4} size={25} />
    </MenuItem>
  );
}

export function MoreTypingSuggestion() {
  return (
    <MenuItem disabled>
      <span>Type more for results</span>
    </MenuItem>
  );
}

export function NoResultSuggestion() {
  return (
    <MenuItem disabled>
      <span>No Results</span>
    </MenuItem>
  );
}
